export default __webpack_public_path__ + "static/media/awards_icon.36e23755.svg";